import {
  Edit,
  SimpleForm,
  TextInput,
  BooleanInput
} from "react-admin";
import {
  hasValue
} from "../../utils/schemas";
import * as Yup from "yup";
import { Grid } from "@mui/material";
import { yupResolver } from "@hookform/resolvers/yup";
import EditTitle from "../../ui/edit-title";
import CustomSaveToolbar from "../../ui/custom-save-toolbar";

const Schema = Yup.object(
{
  name: hasValue(),
  short_name: hasValue()
});

const ExamGroupEdit = () =>
{
  return (
    <Edit
      title={<EditTitle subtitle="Editar Grupo de Exames: " source="name" />}
      redirect="list"
      mutationMode="pessimistic" >
      <SimpleForm
        noValidate
        resolver={yupResolver(Schema)}
        toolbar={ <CustomSaveToolbar /> }>
        <Grid container columnSpacing={2} width="100%">
          <Grid size={{ xs: 1 }}>
            <TextInput source="id" label="Id" fullWidth disabled />
          </Grid>
          <Grid size={{ xs: 5 }}>
            <TextInput source="name" label="Nome" fullWidth isRequired />
          </Grid>
          <Grid size={{ xs: 6 }} />

          <Grid size={{ xs: 6 }}>
            <TextInput source="short_name" label="Nome Abreviado" fullWidth isRequired />
          </Grid>
          <Grid size={{ xs: 6 }} />

          <Grid size={{ xs: 6 }}>
            <BooleanInput source="active" label="Ativo" />
          </Grid>
          <Grid size={{ xs: 6 }} />
        </Grid>
      </SimpleForm>
    </Edit>
  );
};

export default ExamGroupEdit;
